// extracted by mini-css-extract-plugin
export var lineLink = "InfoList-module--line-link--3un94";
export var lineLink_black = "InfoList-module--line-link_black--imH1x";
export var lineLink_grey = "InfoList-module--line-link_grey--E5t8H";
export var lineLink_primary = "InfoList-module--line-link_primary--7wb9O";
export var lineLink_secondary = "InfoList-module--line-link_secondary--yU04k";
export var lineLink_white = "InfoList-module--line-link_white--PQmyt";
export var list = "InfoList-module--list--P2Ow0";
export var listIcon = "InfoList-module--listIcon--TRSgv";
export var listItem = "InfoList-module--listItem--V2lqd";
export var listText = "InfoList-module--listText--6ASww";